import "./App.css";
import { AuthProvider } from "./helper/auth";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import AppRoutes from "./Routes";
import { PurchaseProvider } from "./helper/purchases";
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <PurchaseProvider>
            <div className="font-manrope">
              <Toaster />
              <AppRoutes />
            </div>
          </PurchaseProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
